module.exports = __webpack_public_path__ + "static/media/icon-card-uplift-general.31c79132.svg";